export enum PRINTER_KINDS {
  RECEIPT = 'RECEIPT',
  LABEL = 'LABEL',
}

export enum PRINTER_BRANDS {
  EPSON = 'EPSON',
  STAR = 'STAR',
  ZEBRA = 'ZEBRA',
}

export enum PRINTER_CONNECTIONS {
  NETWORK = 'NETWORK',
  USB = 'USB',
  VIRTUAL = 'VIRTUAL',
}

export enum PRINTER_STATUSES {
  READY = 'READY',
  COVER_OPEN = 'COVER_OPEN',
  LOW_PAPER = 'LOW_PAPER',
  NO_PAPER = 'NO_PAPER',
  PAPER_JAM = 'PAPER_JAM',
  ERROR = 'ERROR',
  DISCONNECTED = 'DISCONNECTED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PAUSED = 'PAUSED',
  OVERHEATED = 'OVERHEATED',
  NOT_RESPONDING = 'NOT_RESPONDING',
}
interface PrinterBase {
  id: string;
  kind: PRINTER_KINDS;
  brand: PRINTER_BRANDS;
  status: PRINTER_STATUSES;
  model?: string; // The model name is not available for some printers (eg: TSP100LAN)
  serial?: string;
  firmware?: string;
}

export interface NetworkPrinter extends PrinterBase {
  connection: PRINTER_CONNECTIONS.NETWORK;
  meta: {
    ip: string;
    port: number;
  };
}

export interface UsbDeviceId {
  vendorId: number;
  productId: number;
}

export interface UsbPrinter extends PrinterBase {
  connection: PRINTER_CONNECTIONS.USB;
  meta: UsbDeviceId & {
    isVendorDrivers: false;
  };
}

export interface UsbVendorDriverPrinter extends PrinterBase {
  connection: PRINTER_CONNECTIONS.USB;
  meta: UsbDeviceId & {
    isVendorDrivers: true;
    portName: string;
    printerName: string;
    driverName: string;
  };
}
export interface VirtualPrinter extends PrinterBase {
  id: string;
  connection: PRINTER_CONNECTIONS.VIRTUAL;
}

export type Printer = NetworkPrinter | UsbPrinter | UsbVendorDriverPrinter | VirtualPrinter;

export enum PLATFORMS {
  MAC = 'MAC',
  WINDOWS = 'WINDOWS',
}

export enum CFD_MODAL_TYPE {
  SETUP = 'SETUP',
  SETTINGS = 'SETTINGS',
}

export enum ACTIONS_DROPDOWN {
  HUB = 'HUB',
  CFD = 'CFD',
}

export enum PRINT_EXECUTION_TIME_EVENTS {
  RETAIL_PRINT_START = 'RETAIL_PRINT_START',
  RETAIL_RECEIPT_LOADED = 'RETAIL_RECEIPT_LOADED',
  RETAIL_HTML_TRANSFORMED = 'RETAIL_HTML_TRANSFORMED',
}

export type ExecutionTimes = { [key in PRINT_EXECUTION_TIME_EVENTS]?: number };
